import { render, staticRenderFns } from "./Novopen.vue?vue&type=template&id=5e858072&scoped=true&"
import script from "./Novopen.vue?vue&type=script&lang=js&"
export * from "./Novopen.vue?vue&type=script&lang=js&"
import style0 from "./Novopen.vue?vue&type=style&index=0&id=5e858072&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e858072",
  null
  
)

export default component.exports